"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeystoneCosmosKeyring = exports.KeystoneCosmosKeyring = exports.KeystoneCosmosInteractionProvider = void 0;
const bc_ur_registry_cosmos_1 = require("@keystonehq/bc-ur-registry-cosmos");
const cosmos_keyring_1 = require("@keystonehq/cosmos-keyring");
const bc_ur_registry_1 = require("@keystonehq/bc-ur-registry");
const utils_1 = require("./utils");
class KeystoneCosmosInteractionProvider {
    constructor() {
        this.readUR = () => __awaiter(this, void 0, void 0, function* () {
            throw new Error("KeystoneError#readUR function is not set.");
        });
        this.playUR = () => __awaiter(this, void 0, void 0, function* () {
            throw new Error("KeystoneError#playUR function is not set.");
        });
        this.readCryptoMultiAccounts = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.readUR();
            return bc_ur_registry_1.CryptoMultiAccounts.fromCBOR(Buffer.from(result.cbor, "hex"));
        });
        this.requestSignature = (cosmosSignRequest, requestTitle, requestDescription) => __awaiter(this, void 0, void 0, function* () {
            const ur = cosmosSignRequest.toUR();
            yield this.playUR({
                type: ur.type,
                cbor: ur.cbor.toString("hex"),
            }, {
                title: requestTitle,
                description: requestDescription,
            });
            const result = yield this.readUR();
            return bc_ur_registry_cosmos_1.CosmosSignature.fromCBOR(Buffer.from(result.cbor, "hex"));
        });
    }
    onReadUR(readUR) {
        this.readUR = readUR;
    }
    onPlayUR(playUR) {
        this.playUR = playUR;
    }
}
exports.KeystoneCosmosInteractionProvider = KeystoneCosmosInteractionProvider;
class KeystoneCosmosKeyring extends cosmos_keyring_1.BaseKeyring {
    constructor() {
        super();
        this.getInteraction = () => {
            return this.interaction;
        };
        this.interaction = new KeystoneCosmosInteractionProvider();
    }
    static getEmptyKeyring() {
        return new KeystoneCosmosKeyring();
    }
    getKeyringData() {
        return {
            xfp: this.xfp,
            device: this.device,
            name: this.name,
            keys: this.getPubKeys().map((e) => {
                const path = utils_1.parseHDPath(`m/${e.hdPath}`);
                return {
                    coinType: path.coinType,
                    bip44HDPath: path.bip44HDPath,
                    pubKey: e.pubKey,
                    index: e.index,
                };
            }),
        };
    }
}
exports.KeystoneCosmosKeyring = KeystoneCosmosKeyring;
KeystoneCosmosKeyring.type = cosmos_keyring_1.BaseKeyring.type;
function useKeystoneCosmosKeyring({ readUR, playUR, keyringData, }) {
    const keyring = KeystoneCosmosKeyring.getEmptyKeyring();
    if (keyringData) {
        const data = Object.assign(Object.assign({}, keyringData), { keys: keyringData.keys.map((e) => ({
                hdPath: `44'/${e.coinType}'/${e.bip44HDPath.account}'/${e.bip44HDPath.change}/${e.bip44HDPath.addressIndex}`,
                index: e.index,
                pubKey: e.pubKey,
            })) });
        keyring.syncKeyringData(data);
    }
    if (readUR) {
        keyring.getInteraction().onReadUR(readUR);
    }
    if (playUR) {
        keyring.getInteraction().onPlayUR(playUR);
    }
    return keyring;
}
exports.useKeystoneCosmosKeyring = useKeystoneCosmosKeyring;
//# sourceMappingURL=cosmos-keyring.js.map